var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "header__dropdown-container" }, [
    _c("div", { staticClass: "header__dropdown-container-inner" }, [
      _c(
        "div",
        {
          staticClass: "header__dropdown-container-links-large-image-container"
        },
        [
          _c(
            "div",
            {
              staticClass:
                "header__dropdown-container-inner-featured-menu-links-container"
            },
            [
              _vm.block.featured_link_list_active
                ? _c(
                    "div",
                    { staticClass: "header__dropdown-side-list" },
                    _vm._l(_vm.block.featured_link_list, function(link, index) {
                      return _c(
                        "ul",
                        { staticClass: "header__dropdown-list" },
                        [
                          _vm.block.title
                            ? _c("li", [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "header__dropdown-list-title header__dropdown-featured-link link link--primary",
                                    attrs: { href: link.url }
                                  },
                                  [_vm._v(_vm._s(link.title))]
                                )
                              ])
                            : _vm._e()
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _c(
                "div",
                {
                  staticClass:
                    "header__dropdown-lists-container header__dropdown-list-menu-links-main-container"
                },
                _vm._l(_vm.block.link_list, function(link, index) {
                  return _c(
                    "ul",
                    {
                      staticClass:
                        "header__dropdown-list header__dropdown-list-menu-links-container"
                    },
                    [
                      _c(
                        "li",
                        {
                          staticClass:
                            "header__dropdown-list-links-image-container"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "header-dropdown-list-links-container"
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "header__dropdown-list-title link link--primary",
                                  class: {
                                    "header__dropdown-list-title--margin-bottom-none": !(
                                      link.children && link.children.length > 0
                                    )
                                  },
                                  attrs: { href: link.url }
                                },
                                [_vm._v(_vm._s(link.title))]
                              ),
                              _vm._l(link.children, function(
                                child_link,
                                index
                              ) {
                                return _c("ul", [
                                  _c(
                                    "li",
                                    {
                                      staticClass: "header__dropdown-list-item"
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "header__dropdown-link link link--primary",
                                          attrs: { href: child_link.url }
                                        },
                                        [_vm._v(_vm._s(child_link.title))]
                                      )
                                    ]
                                  )
                                ])
                              })
                            ],
                            2
                          )
                        ]
                      )
                    ]
                  )
                }),
                0
              )
            ]
          ),
          _c("div", { staticClass: "header__dropdown-image-outer-container" }, [
            _c(
              "a",
              {
                attrs: { href: _vm.block.large_image_link },
                on: {
                  mouseover: function($event) {
                    _vm.hover = true
                  },
                  mouseleave: function($event) {
                    _vm.hover = false
                  }
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "header__dropdown-images-large-image zoom-transition"
                  },
                  [
                    _c("img", {
                      staticClass: "header__dropdown-large-image",
                      attrs: {
                        src: _vm.imageSize(_vm.block.large_image, "600x"),
                        alt: _vm.block.large_image_title,
                        loading: "lazy"
                      }
                    })
                  ]
                )
              ]
            ),
            _c("div", { staticClass: "header-menu-image-title-container" }, [
              _vm.block.large_image_link
                ? _c(
                    "a",
                    {
                      staticClass: "header-menu-image-title link link--primary",
                      class: { hoverimage: _vm.hover },
                      attrs: { href: _vm.block.large_image_link }
                    },
                    [_vm._v(_vm._s(_vm.block.large_image_link_text))]
                  )
                : _vm._e()
            ])
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }